import { array, object, string } from 'yup';
import { pkValidation } from '../../../../utils/pkValidation';
import i18n from '../../../../i18n';
import { PK_FORMAT_REGEX } from '../../../../utils/transform';

export const schemaOT = object({
  // `$isSurveillanceRoute` (2026-07-17): la card de la gemela del RV OCULTA
  // capítulo/subcapítulo (el wizard del RV no los recoge) — sin relajar el
  // required, el guardado de la card quedaría bloqueado por campos invisibles.
  capitol: string().when('$isSurveillanceRoute', ([isSr], schema) =>
    isSr
      ? schema.notRequired()
      : schema.required(() => i18n.t('validation:required')),
  ),
  subCapitol: string().when('$isSurveillanceRoute', ([isSr], schema) =>
    isSr
      ? schema.notRequired()
      : schema.required(() => i18n.t('validation:required')),
  ),
  concession: string().required(() => i18n.t('validation:required')),
  road: string().required(() => i18n.t('validation:required')),
  pkInitRoad: string().required(() => i18n.t('validation:required')),
  pkEndRoad: string().required(() => i18n.t('validation:required')),
  pkInit: string()
    .test('pk-validation', function (value) {
      if (PK_FORMAT_REGEX.test(value || '') && pkValidation(value || '', this.parent)) {
        return true;
      }
      return this.createError({ message: i18n.t('validation:pk.validation') });
    })
    .required(() => i18n.t('validation:required')),
  pkEnd: string()
    .test('pk-validation', function (value) {
      if (PK_FORMAT_REGEX.test(value || '') && pkValidation(value || '', this.parent)) {
        return true;
      }
      return this.createError({ message: i18n.t('validation:pk.validation') });
    })
    .required(() => i18n.t('validation:required')),
  date: string().required(() => i18n.t('validation:required')),
  description: string().required(() => i18n.t('validation:required')),
  // Equipo obligatorio (mín. 1) SOLO cuando el contexto lo pide (`requiresTeam`).
  // El detalle de genérica/campaña (ShowOT/WorkOrder) pasa requiresTeam=true; el de
  // SubWorkOrder (suborden, que NO tiene campo equipo) pasa false, para no bloquear
  // su guardado con un campo inexistente. Mismo patrón yup que el resto de campos
  // required → marca rojo y bloquea el submit automáticamente.
  // `.min(1)` por sí solo NO falla con `undefined`; junto a `.required()` cubre
  // tanto `undefined` como `[]`.
  teamRelationships: array()
    .of(string())
    .when('$requiresTeam', ([requiresTeam], schema) =>
      requiresTeam
        ? schema
            .required(() => i18n.t('validation:required'))
            .min(1, () => i18n.t('validation:required'))
        : schema.notRequired(),
    ),
});
